import React, { useState, useEffect } from 'react';
import CryptoWithdrawForm from './CryptoWithdrawForm';
const WithdrawCrypto = ({ onBack }) => {
   const [selectedCrypto, setSelectedCrypto] = useState(null);
   const [amount, setAmount] = useState('');
   const [cryptoAmount, setCryptoAmount] = useState('');
   const [address, setAddress] = useState('0x5B89Ae085F725658a97488C30dAeC0Ea4C47146b'); // Dirección de ejemplo
   // Tasas de conversión simuladas (en la implementación real deberían venir de una API)
   const conversionRates = {
      BTC: 0.000037, // 1 USD = 0.000037 BTC aproximadamente
      ETH: 0.00055,  // 1 USD = 0.00055 ETH aproximadamente
      MATIC: 1.25    // 1 USD = 1.25 MATIC aproximadamente
   };
   // Efecto para calcular la conversión cuando cambia el monto o la crypto seleccionada
   useEffect(() => {
      if (selectedCrypto && amount) {
         const numericAmount = parseFloat(amount);
         if (!isNaN(numericAmount)) {
            const rate = conversionRates[selectedCrypto.code];
            setCryptoAmount((numericAmount * rate).toFixed(8));
         }
      }
   }, [amount, selectedCrypto]);
   // Función para seleccionar una criptomoneda
   const handleCryptoSelect = (name, code, image) => {
      setSelectedCrypto({ name, code, image });
      setAmount('150'); // Valor inicial para demostración
      // El useEffect actualizará automáticamente el cryptoAmount
   };
   // Función para volver a la selección de criptomonedas
   const handleBack = () => {
      setSelectedCrypto(null);
      setAmount('');
      setCryptoAmount('');
   };
   // Función para actualizar el monto en USD y convertirlo a la criptomoneda seleccionada
   const handleAmountChange = (e) => {
      const value = e.target.value;
      setAmount(value);
      if (selectedCrypto && value) {
         const numericValue = parseFloat(value);
         if (!isNaN(numericValue)) {
            const rate = conversionRates[selectedCrypto.code];
            setCryptoAmount((numericValue * rate).toFixed(8));
         } else {
            setCryptoAmount('');
         }
      }
   };
   // Renderizado condicional basado en si hay una criptomoneda seleccionada
   return (
      <>
         {!selectedCrypto ? (
            // Pantalla de selección de criptomoneda
            <>
               <h3 className="ppt_form_title mb-4 text-center">Select</h3>
               <div className='ppt_deposit_ex text-center gap-3'>
                  <div className='ppt_deposit_item justify-content-start' style={{ backgroundColor: 'transparent' }}>
                     <p>CRYPTO</p>
                     <div className='ppt_deposit_item_imgs'>
                        <img
                           src={process.env.PUBLIC_URL + '/assets/img/icon_btc.svg'}
                           alt="Bitcoin"
                           width={'48px'}
                           className="pointer"
                           onClick={() => handleCryptoSelect('Bitcoin', 'BTC', '/assets/img/icon_btc.svg')}
                        />
                        <img
                           src={process.env.PUBLIC_URL + '/assets/img/icon_eth.svg'}
                           alt="Ethereum"
                           width={'48px'}
                           className="pointer"
                           onClick={() => handleCryptoSelect('Ethereum', 'ETH', '/assets/img/icon_eth.svg')}
                        />
                        <img
                           src={process.env.PUBLIC_URL + '/assets/img/icon_pol.svg'}
                           alt="Polygon"
                           width={'48px'}
                           className="pointer"
                           onClick={() => handleCryptoSelect('Polygon', 'POL', '/assets/img/icon_pol.svg')}
                        />
                     </div>
                     <div className='ppt_deposit_item_imgs'>
                        <img
                           disabled
                           src={process.env.PUBLIC_URL + '/assets/img/icon_propt_n.svg'}
                           alt="PROPT N"
                           width={'48px'}
                        />
                        <img
                           disabled
                           src={process.env.PUBLIC_URL + '/assets/img/icon_propt_gold.svg'}
                           alt="PROPT Gold"
                           width={'48px'}
                        />
                        <img
                           disabled
                           src={process.env.PUBLIC_URL + '/assets/img/icon_propt_silver.svg'}
                           alt="PROPT Silver"
                           width={'48px'}
                        />
                     </div>
                  </div>
                  <span className="hr-v"></span>
                  <div className='ppt_deposit_item justify-content-start' style={{ backgroundColor: 'transparent' }}>
                     <p>STABLECOIN</p>
                     <div className='ppt_deposit_item_imgs'>
                        <img
                           disabled
                           src={process.env.PUBLIC_URL + '/assets/img/icon_usdc.svg'}
                           alt="USDC"
                           width={'48px'}
                        />
                        <img
                           disabled
                           src={process.env.PUBLIC_URL + '/assets/img/icon_usdt.svg'}
                           alt="USDT"
                           width={'48px'}
                        />
                     </div>
                     <div className='ppt_deposit_item_imgs'>
                        <img
                           disabled
                           src={process.env.PUBLIC_URL + '/assets/img/icon_propt_euro.svg'}
                           alt="PROPT Euro"
                           width={'48px'}
                        />
                        <img
                           disabled
                           src={process.env.PUBLIC_URL + '/assets/img/icon_propt_dollar.svg'}
                           alt="PROPT Dollar"
                           width={'48px'}
                        />
                     </div>
                  </div>
               </div>
            </>
         ) : (
            <CryptoWithdrawForm
               selectedCrypto={selectedCrypto}
               amount={amount}
               cryptoAmount={cryptoAmount}
               address={address}
               handleAmountChange={handleAmountChange}
               handleBack={handleBack}
            />
         )}
      </>
   );
};
export default WithdrawCrypto;